export const GeneralHelpIncative = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M16 8C16 9.58225 15.5308 11.129 14.6518 12.4446C13.7727 13.7602 12.5233 14.7855 11.0615 15.391C9.59966 15.9965 7.99113 16.155 6.43928 15.8463C4.88743 15.5376 3.46197 14.7757 2.34315 13.6569C1.22433 12.538 0.462403 11.1126 0.153721 9.56072C-0.15496 8.00887 0.00346629 6.40034 0.608967 4.93853C1.21447 3.47672 2.23985 2.22729 3.55544 1.34824C4.87104 0.469192 6.41775 0 8 0C10.121 0.00229405 12.1545 0.845886 13.6543 2.34568C15.1541 3.84547 15.9977 5.87897 16 8ZM8.66667 9.50467C8.65831 9.27268 8.71121 9.04257 8.82005 8.83753C8.92889 8.63248 9.08983 8.45973 9.28667 8.33667C9.69863 8.10973 10.0432 7.77788 10.2855 7.37477C10.5279 6.97166 10.6592 6.51164 10.6664 6.04136C10.6735 5.57109 10.5561 5.10729 10.3261 4.69702C10.0962 4.28676 9.76177 3.94461 9.35688 3.70529C8.95198 3.46598 8.491 3.33801 8.02069 3.33436C7.55037 3.33071 7.08746 3.45152 6.6789 3.68452C6.27035 3.91753 5.93069 4.25445 5.69437 4.6611C5.45806 5.06775 5.3335 5.52967 5.33334 6H6.66667C6.6665 5.80385 6.70961 5.61008 6.79293 5.43251C6.87625 5.25493 6.99772 5.09793 7.14868 4.97269C7.29964 4.84745 7.47638 4.75706 7.66629 4.70796C7.85619 4.65887 8.05459 4.65228 8.24734 4.68867C8.5107 4.73979 8.75284 4.86826 8.94284 5.05766C9.13283 5.24706 9.26206 5.4888 9.314 5.752C9.36647 6.02827 9.33024 6.31405 9.21051 6.56849C9.09077 6.82293 8.89365 7.033 8.64734 7.16867C8.23945 7.40498 7.9024 7.74634 7.67129 8.1572C7.44018 8.56806 7.32348 9.03337 7.33334 9.50467V10H8.66667V9.50467ZM8.66667 11.3333H7.33334V12.6667H8.66667V11.3333Z"
      fill="url(#paint0_linear_3734_7753)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3734_7753"
        x1="8"
        y1="0"
        x2="8"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0BBCF" />
        <stop offset="1" stopColor="#968FA9" />
      </linearGradient>
    </defs>
  </svg>
);
